/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      // Naechste Seite aus dem Link (auf ?page=3 gelandet -> weiter mit 4)
      this.i = parseInt((this.button && this.button.dataset.nextPage) || 2, 10);
      this.pages = parseInt((this.button && this.button.dataset.pages) || 0, 10);
      this.progress = this.querySelector('[data-pagination-progress]');
    }
    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
    }
    addUrlParam(search, key) {
      var newParam = key + '=' + this.i,
        params = '?' + newParam;

      // If the "search" string exists, then build params from it
      if (search) {
        // Try to replace an existance instance
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

        // If nothing was replaced, then add the new param to the end
        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }
    loadMore() {
      let base = this;
      if (!this.button) return;
      // Der Button ist ein echter Link auf ?page=N (fuer Google und ohne JS);
      // mit JS wird nachgeladen statt die Seite gewechselt.
      this.button.addEventListener('click', function(event) {
        event.preventDefault();
        base.loadProducts();
        this.blur();
      });
    }
    afterLoad() {
      if (this.progress && this.progress.dataset.template) {
        const shown = this.grid.querySelectorAll('.column:not(.promotion-column)').length;
        this.progress.textContent = this.progress.dataset.template.replace('[shown]', shown);
      }
      if (!this.button) return;
      if (this.pages && this.i > this.pages) {
        this.button.classList.add('visually-hidden');
        this.button.setAttribute('aria-hidden', 'true');
        this.button.setAttribute('tabindex', '-1');
      } else {
        this.button.setAttribute('href', document.location.pathname + this.addUrlParam(document.location.search, 'page'));
      }
    }
    infinite() {
      let base = this;
      base.observer = new IntersectionObserver(function(entries) {
        if (entries[0].intersectionRatio === 1) {
          base.loadProducts();
        }
      }, {
        threshold: [0, 1]
      });
      base.observer.observe(base);
    }
    loadProducts() {
      let base = this,
        url = document.location.pathname + base.addUrlParam(document.location.search, 'page');
      if (base.getAttribute('loading')) {
        return;
      }
      base.i++;
      base.setAttribute('loading', true);
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          base.renderProducts(html, url);

          dispatchCustomEvent('pagination:page-changed', {
            url: url
          });
        });
    }
    renderProducts(html, url) {
      let base = this,
        grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');

      if (!grid_to_replace) {
        if (base.observer) {
          base.observer.unobserve(base);
        }
        base.removeAttribute('loading');
        if (base.button) {
          base.button.classList.add('visually-hidden');
        }
        return;
      }
      let products = grid_to_replace.querySelectorAll('.column');

      for (var i = 0; i < products.length; i++) {
        this.grid.appendChild(products[i]);
      }
      if (this.animations_enabled) {
        gsap.set(products, {
          opacity: 0,
          y: 30
        });
        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onComplete: function() {
            base.removeAttribute('loading');
          }
        });
      } else {
        base.removeAttribute('loading');
      }
      base.afterLoad();
    }
  }
  customElements.define('pagination-theme', Pagination);
}